import React from 'react';
import { motion } from 'framer-motion';

const WHATSAPP_NUMBER = '919875630348';
const WHATSAPP_DISPLAY = '+91 98756 30348';
const DEFAULT_MESSAGE =
  "Hello Trade Zone Equipments got details from your website, I'd like to enquire about heavy earth mover spare parts.";

const WhatsAppFloat = () => {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(DEFAULT_MESSAGE)}`;

  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Chat on WhatsApp ${WHATSAPP_DISPLAY}`}
      title={`Chat on WhatsApp · ${WHATSAPP_DISPLAY}`}
      initial={{ opacity: 0, scale: 0.6, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 0.6, type: 'spring', stiffness: 220, damping: 18 }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
      className="fixed z-[60] bottom-5 right-5 sm:bottom-6 sm:right-6 group"
      style={{ WebkitTapHighlightColor: 'transparent' }}
    >
      <span
        aria-hidden="true"
        className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping"
      />
      <span className="relative flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[#25D366] text-white shadow-lg shadow-[#25D366]/40 ring-2 ring-white/10 group-hover:shadow-[#25D366]/60 transition-shadow duration-300">
        <svg
          viewBox="0 0 32 32"
          width="28"
          height="28"
          aria-hidden="true"
          focusable="false"
          className="sm:w-8 sm:h-8"
        >
          <path
            fill="currentColor"
            d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78.876 1.27 2.477 3.176 4.077 3.55 1.075.245 1.762.402 2.36.402.674 0 1.247-.115 1.762-.43.687-.43.974-1.16.974-1.876 0-.115 0-.215-.045-.315-.13-.36-1.673-1.13-1.872-1.13zM16.077 4.5c-6.328 0-11.464 5.135-11.464 11.464 0 2.06.546 4.062 1.58 5.823L4 28l6.347-2.105a11.43 11.43 0 0 0 5.73 1.502c6.328 0 11.464-5.135 11.464-11.464S22.405 4.5 16.077 4.5zm0 21.13a9.65 9.65 0 0 1-4.97-1.36l-.358-.215-3.696 1.232 1.246-3.6-.23-.358a9.66 9.66 0 0 1-1.475-5.124c0-5.346 4.34-9.686 9.683-9.686 5.346 0 9.686 4.34 9.686 9.686s-4.34 9.425-9.686 9.425z"
          />
        </svg>
        <span className="sr-only">Chat on WhatsApp · {WHATSAPP_DISPLAY}</span>
      </span>

      <span
        className="pointer-events-none absolute right-full mr-3 top-1/2 -translate-y-1/2 hidden sm:flex items-center bg-[#1a1a1a] text-white text-sm font-medium px-3 py-2 rounded-lg border border-[#4a4a4a]/40 shadow-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300"
      >
        Chat on WhatsApp
      </span>
    </motion.a>
  );
};

export default WhatsAppFloat;
